module.exports = __webpack_public_path__ + "static/img/cooperator.4487700.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/australia_a_league/cooperator.png
// module id = byKg
// module chunks = 1